module.exports = __webpack_public_path__ + "img/1.41242d6e.png";